export default __webpack_public_path__ + "static/media/alisha-mariam-chacko.26333db5.jpg";